import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import PropTypes from 'prop-types';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';

import './styles/ModalErrorIpTelmex.css';
import logger from 'src/utils/logger/logger';

const ModalError = (props = {}) => {
  const defaultAsset = 'https://clarovideocdn6-a.akamaihd.net/pregeneracion//cms/apa/531eed59e4b050ea818ae755/ic_modal_error.png';
  const defaultTitle = Translator.get('ti_modal_retry','¡Ocurrió algo inesperado!');

  const asset = props.asset || defaultAsset;
  const title = props.title || defaultTitle;

  const codeError = props.content.code;
  let content = Translator.get(codeError);
  const replaces = props.replaces || null;

  if ((content == codeError || content == null) && props.content.message) {
    content = props.content.message;
  }
  if(props.message) content = props.message;

  if(props.session && !props.content.code) content = Translator.get("error_404_not_found", "Servicio no disponible, intentar más tarde");

  if(typeof props.setMetricsEvent === 'function'){
    const sendDimension=()=>{
      const payload=new AnalyticsDimensionSingleton().getPayload();
      props.setMetricsEvent(payload);
      props.setMetricsEvent({ type: 'executor'});
    };
    const sendMetric=()=>{
      props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'errores',
        eventAction: title,
        eventLabel: content,
      });
      props.setMetricsEvent({type:'executor'});
      sendDimension();
    };
    sendMetric();
  }

  const getFooter = () => {
    return (
      <div className='footer'>
        <a className="focusable" href="javascript:void(0)" onClick={(e) => {
          props.handleClose(e, props.callback)
        }}>
          {Translator.get('ip_telmex_close_modal_link_button', 'Cerrar')}
        </a>
      </div>
    );
  };

  const p = {
    content,
    replaces,
    asset: Asset.get(asset, defaultAsset),
    alwaysEnabled: true,
    buttons: [
      {
        content: Translator.get('ip_telmex_retry_mail_button', 'REINTENTAR CON OTRO CORREO'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);},
          className: 'modal-button focusable modal-default-item'
        }
      }
    ],
    children: getFooter(),
    className: props.className
  };
  if (props.title) p.title = Translator.get(title, defaultTitle);

  if (props.withoutTitle) {
    p.title = '';
  }

  if (!props.showFooter) {
    p.children = null;
  }

  return <ModalWrapper {...p} />;
};

ModalError.propTypes = {
  asset: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.object,
  callback: PropTypes.func
};

ModalError.defaultProps = {
  content: {
    code: 'modal_msg_error_default',
    message: 'Por favor vuelve a intentarlo'
  },
  callback: () => { logger.debug('callback...') }
};

export default withOnClose(ModalError);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalErrorIpTelmex.jsx